import type { Location } from "~/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useUpdateLocation(to: any) {
  const { business, selectedLocation } = storeToRefs(useBusinessStore());

  const locations = business.value?.locations;
  if (
    !locations ||
    locations.length === 0 ||
    business.value?.business_status === "closed"
  )
    return;

  const locationIdentifierFromRoute = to.params.location_identifier as string;
  const locationIdFromCookie = Number.parseInt(
    useCookie("selectedLocation").value as string
  );

  selectedLocation.value =
    locations.find(
      (location: Location) =>
        location.identifier === locationIdentifierFromRoute &&
        location.status !== "closed"
    ) ||
    locations.find(
      (location: Location) =>
        location.id === locationIdFromCookie && location.status !== "closed"
    ) ||
    locations.find((location: Location) => location.status !== "closed") ||
    null;

  if (!selectedLocation.value) {
    useCookie("selectedLocation").value = null;
    return;
  }

  useCookie("selectedLocation").value = selectedLocation.value.id.toString();
}
